const bardata = [
  {
    "lesson": "1",
    "score": 25,
    "scoreColor": "hsl(88, 70%, 50%)"
  },
  {
    "lesson": "2",
    "score": 60,
    "scoreColor": "hsl(167, 70%, 50%)"
  },
  {
    "lesson": "3",
    "score": 95,
    "scoreColor": "hsl(13, 70%, 50%)"
  },
  {
    "lesson": "4",
    "score": 60,
    "scoreColor": "hsl(126, 70%, 50%)"
  },
  {
    "lesson": "5",
    "score": 72,
    "scoreColor": "hsl(107, 70%, 50%)"
  },
  {
    "lesson": "6",
    "score": 60,
    "scoreColor": "hsl(91, 70%, 50%)"
  },
  {
    "lesson": "7",
    "score": 35,
    "scoreColor": "hsl(273, 70%, 50%)"
  },


  {
    "lesson": "8",
    "score": 85,
    "scoreColor": "hsl(88, 70%, 50%)"
  },
  {
    "lesson": "9",
    "score": 85,
    "scoreColor": "hsl(167, 70%, 50%)"
  },
  {
    "lesson": "10",
    "score": 70,
    "scoreColor": "hsl(13, 70%, 50%)"
  },
  {
    "lesson": "11",
    "score": 20,
    "scoreColor": "hsl(126, 70%, 50%)"
  },
  {
    "lesson": "12",
    "score": 60,
    "scoreColor": "hsl(107, 70%, 50%)"
  },
  {
    "lesson": "13",
    "score": 95,
    "scoreColor": "hsl(91, 70%, 50%)"
  },
  {
    "lesson": "14",
    "score": 35,
    "scoreColor": "hsl(273, 70%, 50%)"
  },


  {
    "lesson": "15",
    "score": 85,
    "scoreColor": "hsl(88, 70%, 50%)"
  },
  {
    "lesson": "16",
    "score": 85,
    "scoreColor": "hsl(167, 70%, 50%)"
  },
  {
    "lesson": "17",
    "score": 70,
    "scoreColor": "hsl(13, 70%, 50%)"
  },
  {
    "lesson": "18",
    "score": 20,
    "scoreColor": "hsl(126, 70%, 50%)"
  },
  {
    "lesson": "19",
    "score": 60,
    "scoreColor": "hsl(107, 70%, 50%)"
  },
  {
    "lesson": "20",
    "score": 95,
    "scoreColor": "hsl(91, 70%, 50%)"
  },
];

export default bardata;



// WEBPACK FOOTER //
// ./src/assets/data/samplebardata.ts